import { render, staticRenderFns } from "./edit-config-tab.vue?vue&type=template&id=27a92502&scoped=true"
import script from "./edit-config-tab.vue?vue&type=script&lang=js"
export * from "./edit-config-tab.vue?vue&type=script&lang=js"
import style0 from "./edit-config-tab.vue?vue&type=style&index=0&id=27a92502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a92502",
  null
  
)

export default component.exports